<template>
  <div
    :class="['cf-overlay', { 'cf-cursor-wait': withLoader }]"
    @click="overlayClickHandler"
  >
    <div
      v-if="withLoader"
      class="cf-page-loader"
    >
      <div class="cf-loader" />
    </div>
  </div>
</template>


<script>
  export default {
    name: 'CfBackgroundOverlay',

    props: {
      withLoader: {
        type: Boolean,
        default: false
      }
    },

    mounted() {
      this.onComponentMounted();
    },

    unmounted() {
      this.onComponentDestroyed();
    },

    methods: {
      onComponentMounted() {
        document.body.classList.add('cf-overlay-no-scroll');
      },

      onComponentDestroyed() {
        document.body.classList.remove('cf-overlay-no-scroll');
      },

      overlayClickHandler() {
        this.$emit('close-backgound-overlay');
      }
    }
  };
</script>

